module.exports = __webpack_public_path__ + "static/media/crocodile(11).65926a7d.PNG";